import { createEffect } from 'effector';
import api from 'services/api';

export const uploadFileFX = createEffect(
  async ({
    application_uuid,
    application_document,
    file,
    extra_document,
    service_document_uuid,
  }: {
    application_uuid: string | null;
    application_document: string | undefined;
    file: File;
    extra_document?: boolean;
    service_document_uuid?: string;
  }) => {
    const formData = new FormData();
    formData.append('file', file);

    if (extra_document) {
      formData.append('extra_document', '1');
    }

    if (service_document_uuid) {
      formData.append('service_document_uuid', service_document_uuid);
    }

    const response = await api.post(
      application_document
        ? `/api-applications/api/v2/applications/${application_uuid}/document_file/${application_document}`
        : `/api-applications/api/v2/applications/${application_uuid}/document_file`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    const data = { ...response.data.data };

    delete data.additional_options;

    return data;
  }
);
